import React, { useEffect, useState } from 'react';
import { isMobileDevice } from '../utils/deviceDetection';

interface MobileBlockerProps {
  children: React.ReactNode;
  allowMobile?: boolean;
}

const MobileBlocker: React.FC<MobileBlockerProps> = ({ children, allowMobile = false }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(isMobileDevice());
      setIsLoading(false);
    };

    // Check initially
    checkDevice();

    // Listen for resize events
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (isMobile && !allowMobile) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
        <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
          <div className="w-16 h-16 mx-auto mb-6 bg-blue-100 rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            VentraWind
          </h1>
          
          <p className="text-gray-600 mb-6 leading-relaxed">
            Bu yönetim paneli sadece <strong>masaüstü bilgisayarlar</strong> için tasarlanmıştır.
          </p>
          
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-blue-800">
              <strong>Erişim için:</strong><br />
              Lütfen bir bilgisayar veya laptop kullanarak giriş yapın.
            </p>
          </div>
          
          <div className="text-sm text-gray-500">
            <p>© 2025 VentraWind</p>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default MobileBlocker;